import Vue from 'vue'

/*
 * En GET, les paramètres de requête passent par `data`, pas par `params` : auth.fetch recompose
 * sa configuration axios à la main et ne recopie pas `params` (voir ExportRepository).
 */

/**
 * Configuration d'inscription d'une organisation — nouveau module d'onboarding.
 */
class OnboardingConfigurationRepository {

  // GET /api/onboarding/setting-catalogue
  catalogue() {
    return this.fetch({ url: '/api/onboarding/setting-catalogue', method: 'get' })
  }

  // GET /api/onboarding/configurations/{organizationId}[?version=][&policyId=] — policyId absent : la politique par défaut
  get(organizationId, version = null, policyId = null) {
    const params = { ...(version !== null ? { version } : {}), ...(policyId ? { policyId } : {}) }
    return this.fetch({ url: `/api/onboarding/configurations/${organizationId}`, method: 'get', data: params })
  }

  // GET /api/onboarding/configurations/{organizationId}/versions
  versions(organizationId, policyId = null) {
    return this.fetch({ url: `/api/onboarding/configurations/${organizationId}/versions`, method: 'get', data: policyId ? { policyId } : {} })
  }

  // GET /api/onboarding/configurations/{organizationId}/copy-preview?from=
  copyPreview(organizationId, fromOrganizationId) {
    return this.fetch({
      url: `/api/onboarding/configurations/${organizationId}/copy-preview`,
      method: 'get',
      data: { from: fromOrganizationId },
    })
  }

  // POST /api/onboarding/configurations/{organizationId}
  // basedOnVersion : la version chargée par l'écran — un collègue qui a publié entre-temps fait refuser l'envoi.
  publish(organizationId, settings, basedOnVersion, policyId = null) {
    return this.fetch({
      url: `/api/onboarding/configurations/${organizationId}` + (policyId ? `?policyId=${policyId}` : ''),
      method: 'post',
      data: { settings, basedOnVersion },
    })
  }

  // POST /api/onboarding/configurations/{organizationId}/copy
  copy(organizationId, fromOrganizationId, basedOnVersion) {
    return this.fetch({
      url: `/api/onboarding/configurations/${organizationId}/copy`,
      method: 'post',
      data: { fromOrganizationId, basedOnVersion },
    })
  }

  fetch(options) {
    return new Promise((resolve, reject) => {
      Vue.auth.fetch(options)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default new OnboardingConfigurationRepository()
